import React from 'react';
import { Calendar, Clock } from 'lucide-react';

export function BookingsList({ bookings }) {
  return (
    <div className="bg-[#141417] border border-[#27272A] rounded-md p-6">
      <h2 className="text-xl font-bold text-white mb-6" style={{ fontFamily: 'Chivo, sans-serif' }}>
        Your Bookings
      </h2>
      
      {bookings.length > 0 ? (
        <div className="space-y-4">
          {bookings.map(booking => (
            <div 
              key={booking.id}
              className="bg-[#09090B] border border-[#27272A] rounded-md p-4"
              data-testid={`booking-${booking.id}`}
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <Calendar className="w-5 h-5 text-[#007AFF]" />
                  <span className="text-white font-medium">
                    {new Date(booking.date).toLocaleDateString('en-US', { 
                      weekday: 'long', 
                      month: 'short', 
                      day: 'numeric' 
                    })}
                  </span>
                </div>
                <span className={`px-2 py-1 rounded-sm text-xs ${
                  booking.status === 'confirmed' 
                    ? 'bg-[#00FF66]/10 text-[#00FF66]' 
                    : 'bg-[#27272A] text-[#71717A]'
                }`}>
                  {booking.status}
                </span>
              </div>
              <div className="flex items-center gap-2 text-[#A1A1AA] text-sm mb-2">
                <Clock className="w-4 h-4" />
                <span>{booking.time_slot}</span>
              </div>
              <p className="text-white">{booking.topic}</p>
              {booking.notes && (
                <p className="text-[#71717A] text-sm mt-2">{booking.notes}</p>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <Calendar className="w-12 h-12 text-[#71717A] mx-auto mb-4" />
          <p className="text-[#71717A]">No bookings yet</p>
        </div>
      )}
    </div>
  );
}
